<template lang="html">
  <div id="market-page" data-aos="fade">

    <section class="info-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-title">
            <h1 class="title-s1">Mercados y procesos que atendemos</h1>
            <h5 class="subtitle">Fabricamos láminas y rollos de los siguientes materiales</h5>
          </div>
        </div>

        <div class="row row-table-info">
          <div class="col-lg-6 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Poliestireno (HIPS o Ps)</h5>

            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Tipos</th>
                  <th>Usos</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="td-1">Alto Impacto</td>
                  <td class="td-2">Termoformado</td>
                </tr>
                <tr>
                  <td class="td-1">Colores</td>
                  <td class="td-2">Impresión</td>
                </tr>
                <tr>
                  <td class="td-1">Translucidos</td>
                  <td class="td-2">Suaje</td>
                </tr>
                <tr>
                  <td class="td-1">Coextruidos</td>
                  <td class="td-2">Doblez</td>
                </tr>
                <tr>
                  <td class="td-1">Conductivos</td>
                  <td class="td-2"></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5 col-xl-4 col-image" data-aos="fade-up" data-aos-delay="300">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/market/market-1.jpg)' }">
              <img src="public/images/empty.png">
            </div>
          </div>
        </div>

        <div class="row row-table-info">
          <div class="col-lg-6 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Polietileno (PE)</h5>

            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Tipos</th>
                  <th>Uso</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="td-1">Polietileno Baja Densidad (PEBD)</td>
                  <td class="td-2">Termoformado</td>
                </tr>
                <tr>
                  <td class="td-1">Polietileno Media Densidad (PEMD)</td>
                  <td class="td-2">Impresión</td>
                </tr>
                <tr>
                  <td class="td-1">Polietileno Alta Densidad (PEAD)</td>
                  <td class="td-2">Suaje<br />Doblez</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5 col-xl-4 col-image" data-aos="fade-up" data-aos-delay="300">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/market/market-2.jpg)' }">
              <img src="public/images/empty.png">
            </div>
          </div>
        </div>

        <div class="row row-table-info">
          <div class="col-lg-6 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Polipropileno</h5>

            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Tipos</th>
                  <th>Uso</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="td-1">Homopolimeros</td>
                  <td class="td-2">Termoformados</td>
                </tr>
                <tr>
                  <td class="td-1">Copolimeros</td>
                  <td class="td-2">Impresión</td>
                </tr>
                <tr>
                  <td class="td-1">Clarificados</td>
                  <td class="td-2">Suaje</td>
                </tr>
                <tr>
                  <td class="td-1">Colores</td>
                  <td class="td-2">Doblez</td>
                </tr>
                <tr>
                  <td class="td-1">Grabados</td>
                  <td class="td-2">Punto de Venta<br />Tira de Impulso</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-lg-5 col-xl-4 col-image" data-aos="fade-up" data-aos-delay="300">
            <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url(public/images/pages/market/market-3.jpg)' }">
              <img src="public/images/empty.png">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="w-bg mt-4 info-section">
      <div class="container" data-aos="fade">
        <div class="row row-table-info">
          <div class="col-12 mb-3 col-subtitle">
            <h5 class="sub">Capacidades de los equipos</h5>
          </div>

          <div class="col-lg-12 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Impresión</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="td-label">Area de Uso</th>
                    <th class="td-descr">Características Generales</th>
                    <th class="td-label">Materiales</th>
                    <th class="td-descr">Acabados Disponibles</th>
                    <th class="td-label">Coextrusión</th>
                    <th class="td-descr">Presentación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="td-label">Serigrafía</td>
                    <td class="td-descr">Tensión mayor a 36 dinas calibre hasta 0.100", ancho max 126 cm</td>
                    <td class="td-label">PSAI, PEAD, PP</td>
                    <td class="td-descr">Matte, Espejo, Haircell, Rayas diag. Deslizador</td>
                    <td class="td-label">ABA, AB</td>
                    <td class="td-descr">Lamina y Rollo</td>
                  </tr>

                  <tr>
                    <td class="td-label">Offset</td>
                    <td class="td-descr">Tensión mayor a 44 dinas calibre hasta 0.100", ancho max 126 cm</td>
                    <td class="td-label">PSAI, PEAD, PP</td>
                    <td class="td-descr">Matte, Espejo, Haircell, Rayas diag. Deslizador</td>
                    <td class="td-label">ABA, AB</td>
                    <td class="td-descr">Lamina</td>
                  </tr>

                  <tr>
                    <td class="td-label">Impresión Cama Plana</td>
                    <td class="td-descr">
                      Tensión mayor a 44dinas calibre hasta 0.100", ancho max 126 cm
                    </td>
                    <td class="td-label">PSAI, PEAD, PP</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA, AB</td>
                    <td class="td-descr">
                      Lamina y Rollo
                    </td>
                  </tr>

                  <tr>
                    <td class="td-label">P.O.P</td>
                    <td class="td-descr">
                      Tensión mayor a 44 dinas calibre hasta 0.100", ancho max 126 cm
                    </td>
                    <td class="td-label">PSAI, PEAD, PP</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA, AB</td>
                    <td class="td-descr">
                      Lamina
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-lg-12 mt-4 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Formado</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="td-label">Bajo</td>
                    <td class="td-descr">
                      Calibre medio uniforme, alto desempeño, ancho hasta 124 cm
                    </td>
                    <td class="td-label">PSAI, PEBD, PEAD</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA ,AB</td>
                    <td class="td-descr">Lamina y Rollo</td>
                  </tr>

                  <tr>
                    <td class="td-label">Profundo</td>
                    <td class="td-descr">
                      Calibre alto uniforme, alto desempeño, ancho hasta 124 cm
                    </td>
                    <td class="td-label">PSAI, PEBD, PEAD</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA ,AB</td>
                    <td class="td-descr">Lamina</td>
                  </tr>

                  <tr>
                    <td class="td-label">Suajado</td>
                    <td class="td-descr">
                      Calibre bajo y alto uniforme, desempeño, ancho hasta 124 cm
                    </td>
                    <td class="td-label">PSAI, PEBD, PEAD</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA ,AB</td>
                    <td class="td-descr">Lamina y Rollo</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-lg-12 mt-4 col-table" data-aos="fade-up" data-aos-delay="150">
            <h5 class="table-title">Manufactura en General</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="td-label">Bajo</td>
                    <td class="td-descr">
                      Calibre medio uniforme, alto desempeño, ancho hasta 124 cm
                    </td>
                    <td class="td-label">PSAI, PEBD, PEAD</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA, AB</td>
                    <td class="td-descr">Lamina y Rollo</td>
                  </tr>

                  <tr>
                    <td class="td-label">Profundo</td>
                    <td class="td-descr">
                      Calibre alto uniforme, alto desempeño, ancho hasta 124 cm
                    </td>
                    <td class="td-label">PSAI, PEBD, PEAD</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA ,AB</td>
                    <td class="td-descr">Lamina</td>
                  </tr>

                  <tr>
                    <td class="td-label">Suajado</td>
                    <td class="td-descr">
                      Calibre bajo y alto uniforme, desempeño, ancho hasta 124 cm
                    </td>
                    <td class="td-label">PSAI, PEBD, PEAD</td>
                    <td class="td-descr">
                      Matte, Espejo, Haircell, Rayas diag. Deslizador
                    </td>
                    <td class="td-label">ABA ,AB</td>
                    <td class="td-descr">Lamina y Rollo</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
